/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShadowMCPInventoryUserSource,
  ShadowMCPInventoryUserSource$inboundSchema,
} from "./shadowmcpinventoryusersource.js";

export type ShadowMCPInventoryUser = {
  email?: string | undefined;
  lastCalled: Date;
  name?: string | undefined;
  observedUseCount: number;
  sources?: Array<ShadowMCPInventoryUserSource> | undefined;
  userKey: string;
};

/** @internal */
export const ShadowMCPInventoryUser$inboundSchema: z.ZodMiniType<
  ShadowMCPInventoryUser,
  unknown
> = z.pipe(
  z.object({
    email: z.optional(z.string()),
    last_called: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    name: z.optional(z.string()),
    observed_use_count: z.int(),
    sources: z.optional(z.array(ShadowMCPInventoryUserSource$inboundSchema)),
    user_key: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "last_called": "lastCalled",
      "observed_use_count": "observedUseCount",
      "user_key": "userKey",
    });
  }),
);

export function shadowMCPInventoryUserFromJSON(
  jsonString: string,
): SafeParseResult<ShadowMCPInventoryUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShadowMCPInventoryUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShadowMCPInventoryUser' from JSON`,
  );
}
